import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* istanbul ignore file */

import React, { Fragment, useEffect, useState } from 'react';
import * as style from "./FooterLinks.styles";
import { Accordion } from "../Accordion/Accordion";
import { FooterLinksHeading } from "./FooterLinksHeading";
import { FooterLinksList } from "./FooterLinksList";
import { getFooterLinks } from "../../../content/footerLinks";
export var FooterLinks = function FooterLinks() {
  var sections = getFooterLinks();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isClient = _useState2[0],
    setIsClient = _useState2[1];
  useEffect(function () {
    setIsClient(true);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-testid": "footer__links--mobile",
    $_css: style.mobileWrapper
  }, sections.map(function (_ref) {
    var links = _ref.links,
      title = _ref.title;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: title
    }, isClient ? /*#__PURE__*/React.createElement(Accordion, {
      heading: /*#__PURE__*/React.createElement(FooterLinksHeading, {
        title: title
      }),
      key: title
    }, /*#__PURE__*/React.createElement(FooterLinksList, {
      links: links,
      sectionTitle: title
    })) : /*#__PURE__*/React.createElement(FooterLinksList, {
      key: title,
      links: links,
      sectionTitle: title
    }));
  })), /*#__PURE__*/React.createElement(_StyledDiv2, {
    "data-testid": "footer__links--desktop",
    $_css2: style.desktopWrapper
  }, /*#__PURE__*/React.createElement(_StyledUl, {
    $_css3: [style.list]
  }, sections.map(function (_ref2) {
    var links = _ref2.links,
      title = _ref2.title;
    return /*#__PURE__*/React.createElement("li", {
      key: title
    }, /*#__PURE__*/React.createElement(_StyledSpan, {
      $_css4: style.title
    }, title), /*#__PURE__*/React.createElement(FooterLinksList, {
      links: links,
      sectionTitle: title
    }));
  }))));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledUl = _styled3("ul")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledSpan = /*#__PURE__*/_styled4("span").withConfig({
  displayName: "FooterLinks___StyledSpan",
  componentId: "sc-1yd2qbt-0"
})(["", ""], function (p) {
  return p.$_css4;
});